"use strict";
const actionTypes = require('../actionTypes');
function snackbar(snackbarState = { isOpen: false, message: '' }, action) {
    switch (action.type) {
        case actionTypes.DISMISS_SNACKBAR_MESSAGE:
            return {
                isOpen: false,
                message: '',
            };
        case actionTypes.POST_SNACKBAR_MESSAGE:
            return {
                isOpen: true,
                message: action.message,
            };
        case actionTypes.POST_SNACKBAR_APP_UPDATE_AVAILABLE:
            return {
                isOpen: true,
                message: actionTypes.POST_SNACKBAR_APP_UPDATE_AVAILABLE,
            };
        default:
            return snackbarState;
    }
}
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = snackbar;



/** WEBPACK FOOTER **
 ** ./src/reducers/snackbar.ts
 **/